import { useLanguage } from "@/hooks";
import { LANG } from "@/i18n";
import { useToggle } from "ahooks";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Storage from "store";
import "./changeLanguage.scss";
import { useEffect } from "react";
import { query } from "@/utils";
import { defaultLanguage } from "@/i18n";

const overseasExcludeLanguage = [LANG.zhCN, LANG.zhTW];

export const ChangeLanguage = () => {
  const [showHelpModal, { setLeft: closeHelpModal, setRight: openHelpModal }] =
    useToggle(false);
  const { i18n, t } = useTranslation();
  const sysLanguage = useLanguage();

  // 是否是海外标识
  const isOnlyOverseas = query("t") === "overseas";

  const langSelects = [
    {
      label: "简体中文",
      value: LANG.zhCN,
    },
    {
      label: "English",
      value: LANG.enUS,
    },
    {
      label: "繁體中文",
      value: LANG.zhTW,
    },
    {
      label: "Việt Nam",
      value: LANG.vi,
    },
    {
      label: "bahasa Indonesia",
      value: LANG.id,
    },
  ].filter((item) =>
    isOnlyOverseas ? !overseasExcludeLanguage.includes(item.value) : true,
  );

  const itemHandler = (item) => {
    Storage.set("language", item.value);

    switch (item.value) {
      case "en-US":
      case LANG.enUS:
        i18n.changeLanguage(LANG.enUS);
        break;
      case "zh-CN":
      case LANG.zhCN:
        i18n.changeLanguage(LANG.zhCN);
        break;
      case "zh-TW":
      case LANG.zhTW:
        i18n.changeLanguage(LANG.zhTW);
        break;
      case "vi-VN":
      case LANG.vi:
        i18n.changeLanguage(LANG.vi);
        break;
      case LANG.id:
        i18n.changeLanguage(LANG.id);
        break;
      default:
        i18n.changeLanguage(`${sysLanguage}`);
    }

    closeHelpModal();
  };

  const changeLanguage = () => {
    showHelpModal ? closeHelpModal() : openHelpModal();
  };

  useEffect(() => {
    const findLang = langSelects.find((item) => item.value === defaultLanguage);

    // 如果链接写到t=overseas为海外独立访问，过滤中文语种
    if (isOnlyOverseas && !findLang) {
      i18n.changeLanguage(LANG.enUS);
      Storage.set("language", LANG.enUS);
    }
  }, []);

  const currentLanguage = langSelects.find(
    (item) => item.value === i18n.language,
  )?.label;

  return (
    <div className="change-language">
      <span onClick={changeLanguage}>{currentLanguage}</span>
      {showHelpModal && (
        <div className="select-lists">
          {langSelects.map((item) => {
            return (
              <div
                key={item.label}
                onClick={() => itemHandler(item)}
                className="select-item"
              >
                {t(item.label)}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};
